import RouteModel from "../../model-factory/basic/route/RouteModel";
import {FactoryID, RouteKey} from "../../model-factory/type-interface/ModelFactoryType";
import {PostType} from "../../manager/post/PostManager";
import RouteChoice from "../../model-factory/basic/route/RouteChoice";
import RouteFactory from "../../model-factory/basic/route/RouteFactory";
import {IRouteIDs} from "../../model-factory/type-interface/ModelFactoryInterface";

export class PostEntryRouteModel extends RouteModel
{

    navigationRouteKey: RouteKey = "post_entry_route_id";
    choiceOrder = ["applications"];

}

export default class PostEntryRouteFactory extends RouteFactory
{

    id: FactoryID = "post_entry_route";

    constructor()
    {
        super();


        this.choices = {
            applications: new RouteChoice({
                name: "Applications"
            }),
        }
    }

    birth(id: FactoryID): PostEntryRouteModel
    {
        return new PostEntryRouteModel(id);
    }

    getDefaultModel(postType:PostType, postID:number): PostEntryRouteModel | null
    {
        let routeIDs:IRouteIDs;

        routeIDs = {
            browse_route_id: "my_profile",
            my_profile_route_id: postType,
            post_route_id: "list",
            post_list_route_id: postID.toString()
        }
        return this.getDefaultModelWithRoute(routeIDs)! as PostEntryRouteModel;
    }
}